export const FETCH_INITIAL_STATE = 'fetch_initial_state',
  FETCH_INITIAL_STATE_SUCCESS = 'fetch_initial_state_success',
  FETCH_INITIAL_STATE_ERROR = 'fetch_initial_state_error';
